import { defineMessage } from '@lingui/macro';

const UNCLAIMED = 'UNCLAIMED',
  CLAIMED = 'CLAIMED',
  APPROVED = 'APPROVED',
  UNAPPROVED = 'UNAPPROVED',
  REJECTED = 'REJECTED',
  BLOCKED = 'BLOCKED',
  PLANNED = 'PLANNED',
  UNPLANNED = 'UNPLANNED',
  BLOCK_RESOLVED = 'BLOCK_RESOLVED',
  READY_TO_WELD = 'READY_TO_WELD',
  SENT_BACK_TO_PIPING = 'SENT_BACK_TO_PIPING',
  VT_APPROVED = 'VT_APPROVED',
  VT_SENT_BACK = 'VT_SENT_BACK',
  FITUP_INSPECTION = 'FITUP_INSPECTION',
  FITUP_REQUESTED = 'FITUP_REQUESTED',
  ASSIGNED = 'ASSIGNED',
  RECLAIMED = 'RECLAIMED',
  BLOCK_OPENED = 'BLOCK_OPENED',
  REQUESTED = 'REQUESTED',
  CANCELED = 'CANCELED',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  UNASSIGNED = 'UNASSIGNED';

export const MilestoneStatusMessages = {
  [UNCLAIMED]: defineMessage({ message: `Unclaimed` }),
  [CLAIMED]: defineMessage({ message: `Claimed` }),
  [APPROVED]: defineMessage({ message: `Approved` }),
  [UNAPPROVED]: defineMessage({ message: `Unapproved` }),
  [REJECTED]: defineMessage({ message: `Rejected` }),
  [BLOCKED]: defineMessage({ message: `Blocked` }),
  [PLANNED]: defineMessage({ message: `Planned` }),
  [UNPLANNED]: defineMessage({ message: `Unplanned` }),
  [BLOCK_RESOLVED]: defineMessage({ message: `Block Resolved` }),
  [READY_TO_WELD]: defineMessage({ message: `Ready to Weld` }),
  [SENT_BACK_TO_PIPING]: defineMessage({ message: `Sent Back to Piping` }),
  [VT_APPROVED]: defineMessage({ message: `VT Approved` }),
  [VT_SENT_BACK]: defineMessage({ message: `VT Sent Back` }),
  [FITUP_INSPECTION]: defineMessage({ message: `Fitup Inspection` }),
  [ASSIGNED]: defineMessage({ message: `Assigned` }),
  [REQUESTED]: defineMessage({ message: `Requested` }),
  [NOT_APPLICABLE]: defineMessage({ message: `Not Applicable` }),
  [CANCELED]: defineMessage({ message: `Canceled` }),
  [UNASSIGNED]: defineMessage({ message: `Unassigned` }),
  [RECLAIMED]: defineMessage({ message: `Reclaimed` }),
};

export const WeldStatusMessages = {
  [CLAIMED]: defineMessage({ message: `Claimed` }),
  [APPROVED]: defineMessage({ message: `VT Approved` }),
  [REJECTED]: defineMessage({ message: `Rejected` }),
  [BLOCKED]: defineMessage({ message: `Blocked` }),
  [PLANNED]: defineMessage({ message: `Assigned/Planned` }),
  [READY_TO_WELD]: defineMessage({ message: `Ready to Weld` }),
  [VT_SENT_BACK]: defineMessage({ message: `VT Sent Back` }),
  [FITUP_INSPECTION]: defineMessage({ message: `Fitup Inspection` }),
  [ASSIGNED]: defineMessage({ message: `Assigned` }),
  [VT_APPROVED]: defineMessage({ message: `VT Approved` }),
  [SENT_BACK_TO_PIPING]: defineMessage({ message: `Sent Back to Piping` }),
  [FITUP_REQUESTED]: defineMessage({ message: `Fitup Requested` }),
};

const NONE = 'NONE',
  FOREMAN = 'FOREMAN',
  GENERAL_FOREMAN = 'GENERAL_FOREMAN',
  SUPERINTENDENT = 'SUPERINTENDENT',
  FIELD_ENGINEER = 'FIELD_ENGINEER',
  CRAFT = 'CRAFT',
  SUPER_USER = 'SUPER_USER',
  SUPER_ADMIN = 'SUPER_ADMIN',
  PROJECT_ADMIN = 'PROJECT_ADMIN',
  NON_INTERACTIVE_ACCOUNT = 'NON_INTERACTIVE_ACCOUNT',
  FIELD_WELD_ENGINEER = 'FIELD_WELD_ENGINEER',
  ROD_ROOM_ATTENDANT = 'ROD_ROOM_ATTENDANT';

export const PersonaMessages = {
  [NONE]: defineMessage({ message: `NONE` }),
  [FOREMAN]: defineMessage({ message: `Foreman` }),
  [GENERAL_FOREMAN]: defineMessage({ message: `General Foreman` }),
  [SUPERINTENDENT]: defineMessage({ message: `Superintendent` }),
  [FIELD_ENGINEER]: defineMessage({ message: `Field Engineer` }),
  [CRAFT]: defineMessage({ message: `CRAFT` }),
  [SUPER_USER]: defineMessage({ message: `Super User` }),
  [SUPER_ADMIN]: defineMessage({ message: `Super Admin` }),
  [PROJECT_ADMIN]: defineMessage({ message: `Project Admin` }),
  [NON_INTERACTIVE_ACCOUNT]: defineMessage({
    message: `NON INTERACTIVE ACCOUNT`,
  }),
  [ROD_ROOM_ATTENDANT]: defineMessage({ message: `Rod Room Attendant` }),
  [FIELD_WELD_ENGINEER]: defineMessage({ message: `Field Weld Engineer` }),
};

export const MilestoneActivityMessages = {
  [UNCLAIMED]: defineMessage({ message: `Unclaimed` }),
  [CLAIMED]: defineMessage({ message: `Claimed` }),
  [APPROVED]: defineMessage({ message: `Approved` }),
  [UNAPPROVED]: defineMessage({ message: `Unapproved` }),
  [REJECTED]: defineMessage({ message: `Rejected` }),
  [BLOCKED]: defineMessage({ message: `Blocked` }),
  [PLANNED]: defineMessage({ message: `Planned` }),
  [UNPLANNED]: defineMessage({ message: `Unplanned` }),
  [BLOCK_RESOLVED]: defineMessage({ message: `Block Resolved` }),
  [READY_TO_WELD]: defineMessage({ message: `Ready to Weld` }),
  [SENT_BACK_TO_PIPING]: defineMessage({ message: `Sent Back to Piping` }),
  [VT_APPROVED]: defineMessage({ message: `VT Approved` }),
  [VT_SENT_BACK]: defineMessage({ message: `VT Sent Back` }),
  [FITUP_INSPECTION]: defineMessage({ message: `Fitup Inspection` }),
  [ASSIGNED]: defineMessage({ message: `Assigned` }),
  [REQUESTED]: defineMessage({ message: `Requested` }),
  [NOT_APPLICABLE]: defineMessage({ message: `Not Applicable` }),
  [CANCELED]: defineMessage({ message: `Canceled` }),
  [UNASSIGNED]: defineMessage({ message: `Unassigned` }),
  [RECLAIMED]: defineMessage({ message: `Reclaimed` }),
};
